import type { HazardIdentification } from '@/shared/hooks/api/machineryDirectiveCompliance'
import type { TFunction } from 'i18next'

type HazardStandardProvenanceInput = Pick<
  HazardIdentification,
  'source' | 'sourceStandardReference' | 'sourceClauseReference'
>

export function getHazardStandardProvenanceLabel(
  hazard: HazardStandardProvenanceInput,
  translate: TFunction<'machineryDirectiveCompliance'>
): string | null {
  if (hazard.source !== 'AGENT') {
    return null
  }

  const standardReference = hazard.sourceStandardReference?.trim() ?? ''
  const clauseReference = hazard.sourceClauseReference?.trim() ?? ''

  if (standardReference.length > 0 && clauseReference.length > 0) {
    return translate('hazardsPage.hazardStandardProvenance.withClause', {
      standardReference,
      clauseReference,
    })
  }

  if (standardReference.length > 0) {
    return translate('hazardsPage.hazardStandardProvenance.standardOnly', {
      standardReference,
    })
  }

  return translate('hazardsPage.hazardDetail.agent')
}
